import { buildChartOptions } from '@configurations/campaignAnalytics/visitsByHourOfDayChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartCard } from '../ChartCard';
import { EditableChartProps } from './chartProps';

type VisitsByHourOfDayProps = EditableChartProps;

const VisitsByHourOfDay = (props: VisitsByHourOfDayProps) => {
  const { report, ...chartCardProps } = props;

  if (!report) return null;

  return (
    <ChartCard
      title="Visits by Time of Day"
      description={`${props.campaignName} (${props.campaignId})`}
      report={report.visitsByHourOfDay}
      {...chartCardProps}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={buildChartOptions(report.visitsByHourOfDay.data)}
      />
    </ChartCard>
  );
};

export default VisitsByHourOfDay;
